import React from 'react';
import './EVSection.css';

const EVSection = () => (
  <section className="premium-banner">
    <div className="premium-banner-inner">

      <div className="premium-banner-mission-row">
        <div className="premium-banner-rule" />
        <p className="premium-banner-mission">
          The vehicle you want, wherever it is. Purchased with confidence. Delivered with care.
        </p>
        <div className="premium-banner-rule" />
      </div>

      <div className="premium-banner-body">
        <p className="premium-banner-tagline">
          DISCOVER. BUY. CUSTOMIZE. MAINTAIN. MOVE. SELL.
        </p>
        <p className="premium-banner-desc">
          Bw Car Culture gives you access to a wider choice of vehicles, both locally and around
          the world, with the trust and exceptional service every vehicle purchase deserves.
          Choose your vehicle and how you want it. We take care of the entire process, from
          purchase and customization to delivery and ongoing ownership support, all driven by
          our commitment to world-class standards in vehicle quality, care and service.
        </p>
      </div>

    </div>
  </section>
);

export default EVSection;
